/* eslint-disable */
export default {
  header: 'Desactivar el seguimiento de errores',
  content:
    'Desactivar el modo de seguimiento de errores eliminará todos los registros de errores actuales. ¿Desea continuar?',
  confirm: 'Desactivar',
  cancel: 'Cancelar',
} as const;

// @key: @#@"header"@#@ @source: @#@"Turn off error tracking"@#@
// @key: @#@"content"@#@ @source: @#@"Turning off error tracking mode will delete any current error logs. Do you wish to continue?"@#@
// @key: @#@"confirm"@#@ @source: @#@"Turn off"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
